import { TableColumnsSetting } from '@/interfaces/table-setting';
import { RentalReservationModel } from '@/models/rentals/rental-reservation.model';

export class RentalReservationTableSettings {
  public static getColumnsSetting(): TableColumnsSetting<keyof RentalReservationModel> {
    return [
      {
        name: 'btnDetails',
        customComponent: true,
        unsortable: true,
      },
      {
        name: 'btnDelete',
        customComponent: true,
        unsortable: true,
      },
      {
        name: 'id',
        text: 'ID',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'marca',
        text: 'Marca',
        type: 'object',
        propertyToShow: 'descrizioneMarca',
      },
      {
        name: 'rentalPractice',
        text: 'Pratica Noleggio',
        type: 'object',
        propertyToShow: ['targa', 'modello'],
      },
      {
        name: 'veicoloPrenotazioneLibera',
        text: 'Veicolo Prenotazione Libera',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'dataInizio',
        text: 'Data Inizio',
        type: 'date',
        filter: {
          type: 'dateRange',
        },
      },
      {
        name: 'dataFine',
        text: 'Data Fine',
        type: 'date',
        filter: {
          type: 'dateRange',
        },
      },
      {
        name: 'denominazioneCliente',
        text: 'Cliente',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'bpCliente',
        text: 'BP Cliente',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'indirizzoCliente',
        text: 'Indirizzo',
      },
      {
        name: 'cittaCliente',
        text: 'Citta',
      },
      {
        name: 'telefonoCliente',
        text: 'Telefono',
      },
      {
        name: 'emailCliente',
        text: 'Email',
      },
      {
        name: 'note',
        text: 'Note',
      },
      {
        name: 'creator',
        text: 'Creato da',
        filter: {
          type: 'input',
        },
      },
      {
        name: 'created',
        text: 'Creato il',
        type: 'datetime',
        filter: {
          type: 'dateRange',
        },
      },
    ];
  }
}
